/**
 * Platform (super-admin backoffice) role helpers, shared by the router guard and the
 * admin pages. Kept out of App.tsx so lazy-loaded admin pages don't import back into the
 * router module (circular import).
 *
 * - `super_admin`        — the owner: full access, manages the team + all settings.
 * - `super_admin_member` — an invited team member: view-all, writes only where the server
 *                          marks a route @ViewerWritable (P&L one-off entries + chat).
 */
export const PLATFORM_ROLES = ['super_admin', 'super_admin_member'] as const;

/** Can reach the /admin backoffice at all (owner or member). */
export const isPlatformRole = (role?: string): boolean =>
  role === 'super_admin' || role === 'super_admin_member';

/** The full owner — the only one who can manage the team and change platform settings. */
export const isPlatformOwner = (role?: string): boolean => role === 'super_admin';

/** A view-only platform team member (not the owner). */
export const isPlatformMember = (role?: string): boolean => role === 'super_admin_member';
